import React from 'react';
import PropTypes from 'prop-types';
import { Card, Button, Icon } from 'semantic-ui-react';
import _ from 'lodash';
import AuthorisationButton from '../../components/authorisation-button';

const containerStyle = {
  width: 600,
  margin: '0 auto',
};

const YouTubeLink = () => (
  <a href="https://www.youtube.com/watch?v=cpBMyaEkDPI" target="_blank">
    <span>here <Icon name="youtube play" color="red" size="large" /></span>
  </a>
);
const MissingPermissions = ({
  declinedPermissions,
  onContinueClick,
}) => (
  <div style={containerStyle}>
    <Card color="red" fluid>
      <Card.Content textAlign="center">
        <Icon name="x" color="orange" size="massive" />
      </Card.Content>
      <Card.Content textAlign="center">
        <Card.Header>
        PERMISSIONS REMOVED
        </Card.Header>
      </Card.Content>
      <Card.Content>
        <p>It looks like you have removed the following permission(s).</p>
        <ul>
          {
            _.map(declinedPermissions, dp => (<li><code>{dp.permission}</code></li>))
          }
        </ul>
        <p>We need this to generate a secure access token to fetch your Instagram Insights data.</p>
        <br />
        <p>We only ever have read access to your data, we cannot edit or delete anything.</p>
        <br />
        <p>Click <YouTubeLink /> to view an explainer video of the process.</p>

      </Card.Content>
      <Card.Content>
        <p>Please click the button below to restart the Authorisation process.</p>
      </Card.Content>
    </Card>
    <Card.Content>


      <AuthorisationButton
        platform={'instagram'}
        disabled={false}
        handleAuthClick={onContinueClick}
      />

    </Card.Content>

  </div>
);

MissingPermissions.propTypes = {
  declinedPermissions: PropTypes.array.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default MissingPermissions;



/** WEBPACK FOOTER **
 ** ./src/containers/token-generation-page/missing-permissions.js
 **/